import { useState, useContext } from 'react'

import { AuthContext } from '../../contexts/auth'

import { Container } from './styles'

import loginImg from '../../assets/img1.png'
//import { Link } from 'react-router-dom'

export function SignIn() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { signInUser, loadingAuth } = useContext(AuthContext)

  function handleLoginUser(e) {
    e.preventDefault()

    signInUser(email, password)
    //console.log(email)
  }


  return (
    <Container>
      <div className='box1'>
        <div className='box-description'>
          <h2>Plataforma de Questões</h2>
          <strong>Prepare-se para o seu concurso na melhor plataforma de questões!</strong>
        </div>
        <img src={loginImg} alt="imagem de tela de login" />

      </div>
      <div className='box2'>
        <h2>Faça seu login</h2>
        <form onSubmit={handleLoginUser} >
          <label>Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder='seu email' />
          <label>Senha</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} placeholder='sua senha' type='password' />
          <button>{loadingAuth ? "Carregando..." : "Acessar"}</button>
        </form>
      </div>

    </Container>
  )
}